import { TablePagination } from "@mui/material";
import { countryTr } from "../../util/countryTr";
import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import noImage from "../../assets/img/female.png";

//action
import {
  getHostRequest,
  hostRequestAccept,
  hostRequestDecline,
  getAgencyOptions,
} from "../../store/hostRequest/hostRequest.action";

//type
import { OPEN_HOST_REQUEST_DIALOG } from "../../store/hostRequest/hostRequest.type";

// pagination
import TablePaginationActions from "../../util/Pagination";

// component
import HostRequestEdit from "../Dialog/HostRequestEdit";

const HostRequest = (props) => {
  const dispatch = useDispatch();

  const { hostRequest, agencies } = useSelector((state) => state.hostRequest);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [tab, setTab] = useState("pending");

  // onay/red penceresi: {mode:"accept"|"decline", row}
  const [modal, setModal] = useState(null);
  const [agencyId, setAgencyId] = useState("");
  const [reason, setReason] = useState("");

  useEffect(() => {
    dispatch(getHostRequest());
    dispatch(getAgencyOptions());
  }, [dispatch]);

  // sekme + arama birlikte suzulur
  const data = useMemo(() => {
    const list = (hostRequest || []).filter((r) => (tab === "pending" ? !r.isRejected : r.isRejected));
    const v = search.trim().toUpperCase();
    if (!v) return list;
    return list.filter(
      (d) =>
        d?.name?.toUpperCase()?.indexOf(v) > -1 ||
        d?.email?.toUpperCase()?.indexOf(v) > -1 ||
        d?.gender?.toUpperCase()?.indexOf(v) > -1 ||
        d?.bio?.toUpperCase()?.indexOf(v) > -1 ||
        d?.uniqueID?.toString()?.indexOf(v) > -1 ||
        d?.country?.toUpperCase()?.indexOf(v) > -1 ||
        d?.age?.toString()?.indexOf(v) > -1
    );
  }, [hostRequest, tab, search]);

  useEffect(() => {
    setPage(0);
  }, [tab, search]);

  const counts = useMemo(
    () => ({
      pending: (hostRequest || []).filter((r) => !r.isRejected).length,
      rejected: (hostRequest || []).filter((r) => r.isRejected).length,
    }),
    [hostRequest]
  );

  const openAccept = (row) => {
    setAgencyId("");
    setModal({ mode: "accept", row });
  };

  const openDecline = (row) => {
    setReason("");
    setModal({ mode: "decline", row });
  };

  const confirmModal = () => {
    if (!modal) return;
    if (modal.mode === "accept") {
      props.hostRequestAccept(modal.row._id, agencyId || null);
    } else {
      props.hostRequestDecline(modal.row._id, reason);
    }
    setModal(null);
  };

  const handleEditRequest = (row) => {
    dispatch({ type: OPEN_HOST_REQUEST_DIALOG, payload: row });
  };

  const fallback = (e) => {
    e.target.onerror = null;
    e.target.src = noImage;
  };

  const S = styles;

  return (
    <>
      <div className="row py-2">
        <div className="col-6">
          <h4 className="hostTitle">Host Başvuruları</h4>
        </div>
        <div className="col-6">
          <div className="breadcrumb-four float-right">
            <ul className="breadcrumb">
              <li>
                <Link to="/admin/dashboard">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-home"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <polyline points="9 22 9 12 15 12 15 22" />
                  </svg>
                </Link>
              </li>
              <li className="active">
                <a href={() => false}> HostRequest </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row layout-top-spacing">
        <div className="col-lg-12 col-12 layout-spacing">
          <div className="statbox widget">
            <div className="widget-content widget-content-area" style={S.area}>
              {/* sekmeler + arama */}
              <div style={S.toolbar}>
                <div style={S.tabs}>
                  <button
                    type="button"
                    style={{ ...S.tab, ...(tab === "pending" ? S.tabOn : {}) }}
                    onClick={() => setTab("pending")}
                  >
                    Bekleyen <span style={S.count}>{counts.pending}</span>
                  </button>
                  <button
                    type="button"
                    style={{ ...S.tab, ...(tab === "rejected" ? S.tabOn : {}) }}
                    onClick={() => setTab("rejected")}
                  >
                    Reddedilen <span style={S.count}>{counts.rejected}</span>
                  </button>
                </div>
                <input
                  type="text"
                  style={S.search}
                  placeholder="İsim, e-posta, ülke, ID ara…"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              {/* kart listesi */}
              {data.length > 0 ? (
                (rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data).map(
                  (row) => (
                    <div key={row._id} style={S.card}>
                      <img src={row?.image} onError={fallback} alt="" style={S.avatar} draggable="false" />

                      <div style={S.info}>
                        <div style={S.nameRow}>
                          <span style={S.name}>{row?.name}</span>
                          <span style={S.id}>#{row?.uniqueID}</span>
                          {row?.isRejected ? (
                            <span style={{ ...S.badge, ...S.badgeRed }}>Reddedildi</span>
                          ) : (
                            <span style={{ ...S.badge, ...S.badgeAmber }}>Bekliyor</span>
                          )}
                        </div>

                        <div style={S.meta}>
                          <span>{row?.email}</span>
                          <span style={S.dot}>•</span>
                          <span>{countryTr(row?.country)}</span>
                          <span style={S.dot}>•</span>
                          <span>{row?.age} yaş</span>
                          <span style={S.dot}>•</span>
                          <span>{row?.gender === "Female" ? "Kadın" : row?.gender === "Male" ? "Erkek" : row?.gender}</span>
                          {row?.date && (
                            <>
                              <span style={S.dot}>•</span>
                              <span>{row.date}</span>
                            </>
                          )}
                        </div>

                        {row?.bio && <div style={S.bio}>{row.bio}</div>}

                        {row?.isRejected && row?.rejectReason && (
                          <div style={S.reason}>Red sebebi: {row.rejectReason}</div>
                        )}
                      </div>

                      <div style={S.actions}>
                        {row?.video ? (
                          <a href={row.video} target="_blank" rel="noreferrer" style={{ ...S.btn, ...S.btnGhost }}>
                            ▶ Video
                          </a>
                        ) : (
                          <span style={{ ...S.btn, ...S.btnGhost, opacity: 0.45, cursor: "default" }}>Video yok</span>
                        )}
                        <button type="button" style={{ ...S.btn, ...S.btnGhost }} onClick={() => handleEditRequest(row)}>
                          Düzenle
                        </button>
                        {!row?.isRejected && (
                          <button type="button" style={{ ...S.btn, ...S.btnRed }} onClick={() => openDecline(row)}>
                            Reddet
                          </button>
                        )}
                        <button type="button" style={{ ...S.btn, ...S.btnGreen }} onClick={() => openAccept(row)}>
                          Kabul et
                        </button>
                      </div>
                    </div>
                  )
                )
              ) : (
                <div style={S.empty}>
                  {tab === "pending" ? "Bekleyen başvuru yok." : "Reddedilmiş başvuru yok."}
                </div>
              )}

              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100, { label: "Tümü", value: data?.length || 1 }]}
                component="div"
                count={data?.length || 0}
                page={page}
                onPageChange={(e, p) => setPage(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                ActionsComponent={TablePaginationActions}
                labelRowsPerPage="Sayfa başına"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
              />
            </div>
          </div>
        </div>

        <HostRequestEdit />
      </div>

      {/* onay / red penceresi */}
      {modal && (
        <div style={S.overlay} onClick={() => setModal(null)}>
          <div style={S.modal} onClick={(e) => e.stopPropagation()}>
            <div style={S.modalHead}>
              <img src={modal.row?.image} onError={fallback} alt="" style={S.modalAvatar} />
              <div>
                <div style={S.modalName}>{modal.row?.name}</div>
                <div style={S.modalSub}>
                  {countryTr(modal.row?.country)} • {modal.row?.age} yaş
                </div>
              </div>
            </div>

            {modal.mode === "accept" ? (
              <>
                <div style={S.label}>Ajansa ekle (isteğe bağlı)</div>
                <select style={S.input} value={agencyId} onChange={(e) => setAgencyId(e.target.value)}>
                  <option value="">Ajans yok — bağımsız yayıncı</option>
                  {(agencies || []).map((a) => (
                    <option key={a._id} value={a._id}>
                      {a.name} ({a.code}) — {a.hostCount || 0} yayıncı
                    </option>
                  ))}
                </select>
                <div style={S.hint}>
                  Onaylandığında kullanıcıya kendi dilinde bildirim gider. Ajans seçersen yayıncı doğrudan o ajansa
                  bağlanır.
                </div>
              </>
            ) : (
              <>
                <div style={S.label}>Red sebebi (isteğe bağlı)</div>
                <textarea
                  style={{ ...S.input, height: 90, resize: "vertical" }}
                  placeholder="Örn: Tanıtım videosu net değil, tekrar çekip başvurabilirsin."
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  maxLength={300}
                />
                <div style={S.hint}>
                  Yazdığın sebep kullanıcıya bildirim olarak aynen iletilir. Boş bırakırsan yalnız standart mesaj gider.
                </div>
              </>
            )}

            <div style={S.modalFoot}>
              <button type="button" style={{ ...S.btn, ...S.btnGhost }} onClick={() => setModal(null)}>
                Vazgeç
              </button>
              <button
                type="button"
                style={{ ...S.btn, ...(modal.mode === "accept" ? S.btnGreen : S.btnRed) }}
                onClick={confirmModal}
              >
                {modal.mode === "accept" ? "Onayla ve bildir" : "Reddet ve bildir"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  area: { padding: 18 },
  toolbar: { display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", justifyContent: "space-between", marginBottom: 16 },
  tabs: { display: "flex", gap: 8 },
  tab: {
    border: "1px solid #e3e7ef",
    background: "#fff",
    color: "#5b6478",
    borderRadius: 10,
    padding: "8px 16px",
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
  },
  tabOn: { background: "#4361ee", borderColor: "#4361ee", color: "#fff" },
  count: {
    display: "inline-block",
    marginLeft: 7,
    background: "rgba(0,0,0,.12)",
    borderRadius: 20,
    padding: "1px 8px",
    fontSize: 12,
  },
  search: {
    flex: "1 1 260px",
    maxWidth: 360,
    border: "1px solid #e3e7ef",
    borderRadius: 10,
    padding: "9px 14px",
    fontSize: 14,
    outline: "none",
  },
  card: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexWrap: "wrap",
    border: "1px solid #eceff5",
    borderRadius: 14,
    padding: 14,
    marginBottom: 12,
    background: "#fff",
    boxShadow: "0 1px 3px rgba(20,30,60,.05)",
  },
  avatar: { width: 62, height: 62, borderRadius: 12, objectFit: "cover", flexShrink: 0, background: "#f2f4f8" },
  info: { flex: "1 1 320px", minWidth: 0 },
  nameRow: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
  name: { fontWeight: 700, fontSize: 16, color: "#1b2334" },
  id: { color: "#8b93a7", fontSize: 13 },
  badge: { fontSize: 11, fontWeight: 700, borderRadius: 20, padding: "2px 10px" },
  badgeAmber: { background: "#fff3d6", color: "#9a6700" },
  badgeRed: { background: "#ffe3e3", color: "#b42318" },
  meta: { marginTop: 4, fontSize: 13, color: "#6b7280", display: "flex", flexWrap: "wrap", gap: 4 },
  dot: { color: "#c8cddb" },
  bio: { marginTop: 6, fontSize: 13, color: "#4b5563" },
  reason: { marginTop: 6, fontSize: 13, color: "#b42318", background: "#fff5f5", borderRadius: 8, padding: "6px 10px" },
  actions: { display: "flex", gap: 8, flexWrap: "wrap", marginLeft: "auto" },
  btn: {
    border: "1px solid transparent",
    borderRadius: 10,
    padding: "8px 16px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-block",
  },
  btnGhost: { background: "#fff", borderColor: "#dde2ec", color: "#42506b" },
  btnGreen: { background: "#12b76a", color: "#fff" },
  btnRed: { background: "#f04438", color: "#fff" },
  empty: { textAlign: "center", color: "#8b93a7", padding: "48px 0", fontSize: 15 },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(16,22,38,.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1300,
    padding: 16,
  },
  modal: { width: "100%", maxWidth: 460, background: "#fff", borderRadius: 16, padding: 22 },
  modalHead: { display: "flex", alignItems: "center", gap: 12, marginBottom: 18 },
  modalAvatar: { width: 48, height: 48, borderRadius: 10, objectFit: "cover", background: "#f2f4f8" },
  modalName: { fontWeight: 700, fontSize: 16, color: "#1b2334" },
  modalSub: { fontSize: 13, color: "#6b7280" },
  label: { fontSize: 13, fontWeight: 600, color: "#42506b", marginBottom: 6 },
  input: {
    width: "100%",
    border: "1px solid #dde2ec",
    borderRadius: 10,
    padding: "10px 12px",
    fontSize: 14,
    outline: "none",
  },
  hint: { fontSize: 12, color: "#8b93a7", marginTop: 8, lineHeight: 1.5 },
  modalFoot: { display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 },
};

export default connect(null, { getHostRequest, hostRequestAccept, hostRequestDecline, getAgencyOptions })(HostRequest);
